"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactRouterDom = require("react-router-dom");

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _addonKnobs = require("@storybook/addon-knobs");

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _styled = require("./styled.Header");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var MobileNavbar = function MobileNavbar(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props);
  var style = newProps.style,
      content = newProps.content,
      media = newProps.media,
      links = newProps.links;


  var link1 = getPropValue("text", "link1", links.link1, "content");
  var url1 = getPropValue("text", "url1", links.url1, "content");
  var link2 = getPropValue("text", "link2", links.link2, "content");
  var url2 = getPropValue("text", "url2", links.url2, "content");
  var link3 = getPropValue("text", "link3", links.link3, "content");
  var url3 = getPropValue("text", "url3", links.url3, "content");

  var classes = "mobile-menu ";
  if (props.navbarShow) {
    classes += "show";
  }

  return _react2.default.createElement(
    _styled.MobileMenu,
    { className: classes },
    _react2.default.createElement(
      _reactBootstrap.Navbar.Collapse,
      null,
      props.children,
      _react2.default.createElement(
        _reactBootstrap.Nav,
        { as: "ul", className: "d-block" },
        _react2.default.createElement(
          _styled.StyledLi,
          null,
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { className: "nav-link", to: "/home" },
            link1
          )
        ),
        _react2.default.createElement(
          _styled.StyledLi,
          null,
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { className: "nav-link", to: "/enterprise" },
            link2
          )
        ),
        _react2.default.createElement(
          _styled.StyledLi,
          null,
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { className: "nav-link", to: "/pricing" },
            link3
          )
        )
      )
    )
  );
};
exports.default = MobileNavbar;